export default [
    { key: 0, value: "EAN13" },
    { key: 1, value: "EAN128" },
    { key: 2, value: "CODE39" },
    { key: 3, value: "QRCODE" }
]